import React, { useState } from "react";

const CardBoxTwo = ({
  isAdmin,
  iconOne,
  iconTwo,
  iconThree,
  titreOne,
  titreTwo,
  titreThree,
  numberOne,
  numberTwo,
  DirectionBtnOne,
  seuilClient,
  setOnConfigSeuil,
  isSelectedClient,
  DirectionBtnTwo,
  isShowDetailsBtn,
  seuilClientvalue,
}) => {
  const onConfigSeuilClient = () => {
    setOnConfigSeuil(true);
  };

  return (
    <div className="row">
      <div
        className={
          isAdmin && isShowDetailsBtn ? "col-sm-4 col-12" : "col-sm-6 col-12"
        }
      >
        <div className="info-box bg-danger">
          <span className="info-box-icon">
            <i className={iconOne}></i>
          </span>

          <div className="info-box-content">
            <span className="info-box-text">{titreOne}</span>
            <span className="info-box-number">{numberOne} TND</span>
          </div>
          {isShowDetailsBtn && (
            <button
              className="btn btn-sm"
              onClick={() => {
                DirectionBtnOne();
              }}
            >
              <b>Voir Details</b>
            </button>
          )}
        </div>
      </div>
      <div
        className={
          isAdmin && isShowDetailsBtn ? "col-sm-4 col-12" : "col-sm-6 col-12"
        }
      >
        <div className="info-box bg-warning">
          <span className="info-box-icon">
            <i className={iconTwo}></i>
          </span>

          <div className="info-box-content">
            <span className="info-box-text">{titreTwo}</span>
            <span className="info-box-number">{numberTwo} TND</span>

            {/* <div className="progress">
              <div className="progress-bar" style={{ width: "70%" }}></div>
            </div>
            <span className="progress-description">
              70% Increase in 30 Days
            </span> */}
          </div>
          {isShowDetailsBtn && (
            <button
              className="btn btn-sm"
              onClick={() => {
                DirectionBtnTwo();
              }}
            >
              <b>Voir Details</b>
            </button>
          )}
        </div>
      </div>
      {isAdmin && isShowDetailsBtn && (
        <div className="col-sm-4 col-12">
          <div className="info-box bg-danger">
            <span className="info-box-icon">
              <i className={iconThree}></i>
            </span>

            <div className="info-box-content">
              <span className="info-box-text">{titreThree}</span>
              <span className="info-box-number">
                {seuilClient ? seuilClientvalue : "non configuré"}
              </span>

              {/* <div className="progress">
              <div className="progress-bar" style={{ width: "70%" }}></div>
            </div>
            <span className="progress-description">
              70% Increase in 30 Days
            </span> */}
            </div>
            {/* {!seuilClient && ( */}
            <button
              className="btn btn-sm"
              data-toggle="modal"
              data-target="#configurer-seuil-client"
              onClick={onConfigSeuilClient}
            >
              <b>Configurer</b>
            </button>
            {/* )} */}
          </div>
        </div>
      )}
    </div>
  );
};
export default CardBoxTwo;
